export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_08.318712c2.mp4";